import { mapCurrentUser } from '../utils/store'

export default {
  computed: {
    ...mapCurrentUser(),
  },
}
